import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-core-services',
  template: `
    <p>
      core-services works!
    </p>
  `,
  styles: [
  ]
})
export class CoreServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
